module.exports = __webpack_public_path__ + "img/theme-su-studio.f02295cb.jpg";